import React from 'react'
import { useSelector } from 'react-redux'
import ConfirmationPopupContent from 'src/components/ConfirmationPopupContent/ConfirmationPopupContent'
import Popup from 'src/components/Popup/Popup'
import { useTranslate } from 'src/localization/Trns'
import { usePutOrgPhysicalClearingsEnabled } from 'src/queries/organizations/physicalClearings.queries'
import { selectAppName } from 'src/redux/selectors/session.selectors'

interface DisconnectBankFeedPopupProps {
  organizationId: string
  closePopup: () => void
}
const DisconnectBankFeedPopup: React.FC<DisconnectBankFeedPopupProps> = (
  props,
) => {
  const translate = useTranslate()

  const appName = useSelector(selectAppName)
  const {
    mutate: putOrgPhysicalClearingsEnabled,
    isPending: putOrgPhysicalClearingsEnabledLoading,
    isSuccess: disconnectSuccess,
  } = usePutOrgPhysicalClearingsEnabled(props.organizationId)

  if (disconnectSuccess) {
    props.closePopup()
  }

  return (
    <Popup onClose={props.closePopup}>
      <ConfirmationPopupContent
        title={translate('Disconnect Bank Feed')}
        subtitle={translate(
          'If you choose to disable the bank data feed, future physical card transactions will no longer display in ${brandName}. You can re-enable the data feed at any time.',
          {
            brandName: appName,
          },
        )}
        actionButtonLabel={translate('Confirm Disconnect')}
        actionButtonLoading={putOrgPhysicalClearingsEnabledLoading}
        actionButtonOnClick={(): void => {
          putOrgPhysicalClearingsEnabled({
            id: props.organizationId,
            body: {
              enabled: false,
            },
          })
        }}
        cancelButtonLabel={translate('Cancel')}
        cancelButtonOnClick={props.closePopup}
      />
    </Popup>
  )
}

export default DisconnectBankFeedPopup
